/* eslint-disable no-undef */

/**
 * class for managing Sentry connection / events
 */
class SentryLogger {
  /**
   * constructor
   */
  constructor() {
    this._debugMode = false;
  }

  /**
   * connect / init sentry
   * @param {string} sentryDSN
   * @param {Object} sentryCFG
   * @param {string} gameVersion
   */
  connect(sentryDSN, sentryCFG, gameVersion) {
    try {
      if (sentryDSN && sentryCFG) {
        Sentry.init({
          debug: this._debugMode,
          dsn: sentryDSN,
          release: `${sentryCFG.projectId}@${gameVersion}`,
        });
      } else if (sentryDSN) {
        Sentry.init({
          debug: this._debugMode,
          dsn: sentryDSN,
        });
      }
    } catch (error) {
      console.log('ERROR: could not connect to sentry');
    }
  }

  /**
   * manually log a sentry error
   * @param {string} message
   * @param {Object} optOptions
   * @param {boolean} debug
   */
  logError(message, optOptions, debug = true) {
    try {
      if (debug) {
        G.Utils.debugError(message);
      }
      if (typeof Sentry !== 'undefined') {
        Sentry.captureMessage(message, optOptions);
      }
    } catch (error) {
      console.log('Sentry Error: could not logError.');
    }
  }

  /**
   * set the user context for sentry
   * @param {string} userId
   */
  setUserContext(userId) {
    try {
      Sentry.configureScope((scope) => {
        scope.setUser({
          id: userId,
        });
      });
    } catch (error) {
      console.log('Sentry Error: could not setUserContext.');
    }
  }
}

// create global instance
G.Utils.SentryLog = new SentryLogger();
